import { ROLE_TYPES } from '@digitale-verhuurders-verklaring/core/src/models/functions/authentication/types';
import {
  type CurrentUserDto,
  currentUserDtoSchema,
} from '@digitale-verhuurders-verklaring/core/src/models/shared/rds/user';
import { JsonSuccessResponse } from '@digitale-verhuurders-verklaring/core/src/models/shared/types';
import { useQuery } from '@tanstack/vue-query';

import { useAxiosClient } from '../utils/useAxiosClient';

export type { CurrentUserDto };

export const currentUserQueryKey = ['currentUser'] as const;

/**
 * Standalone fetch for current user (e.g. from router guard).
 * Uses axios client with current session token. Throws on non-2xx or missing token.
 */
export const fetchCurrentUser = async (): Promise<CurrentUserDto> => {
  const client = await useAxiosClient();
  const res = await client.get<JsonSuccessResponse<CurrentUserDto>>(
    '/handlers/getCurrentUser',
  );
  return currentUserDtoSchema.parse(res.data.data);
};

export const useGetCurrentUser = () => {
  const query = useQuery({
    queryKey: currentUserQueryKey,
    queryFn: fetchCurrentUser,
  });
  return query;
};

/**
 * Roles from current user DTO as ROLE_TYPES[] (API returns valid role names).
 */
export const currentUserRolesAsEnum = (
  roles: string[] | undefined,
): ROLE_TYPES[] => (roles ?? []) as ROLE_TYPES[];
